import { useValidationsField } from '@insurance/hooks'
import { usePermissionRestriction } from '@shared/hooks'
import { AppPermissions } from '@shared/types'
import { Checkbox, Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
  isEditable?: boolean
  contractorKey?: string
  resident?: boolean
  notRequiredIdno?: boolean
}

export const ContractorLegalPerson = ({
  isEditable = false,
  contractorKey = 'contractor',
  notRequiredIdno,
  children
}: React.PropsWithChildren<Props>) => {
  const { t } = useTranslation()
  const { required, legalPersonalCode, companyName, fiscalCode } =
    useValidationsField()
  const { hasPermission } = usePermissionRestriction()
  const isFiscalCodeField = Form.useWatch([
    contractorKey,
    'legal_entity',
    'is_fiscal_code'
  ])

  const isFiscalCode =
    isFiscalCodeField && hasPermission([AppPermissions.FISCAL_CODE_ENTITY])

  return (
    <Row gutter={12} align="bottom">
      {hasPermission([AppPermissions.FISCAL_CODE_ENTITY]) && (
        <Col span={24}>
          <Form.Item
            name={[contractorKey, 'legal_entity', 'is_fiscal_code']}
            valuePropName="checked"
          >
            <Checkbox disabled={isEditable}>
              {t('organization_without_idno')}
            </Checkbox>
          </Form.Item>
        </Col>
      )}

      <Col xs={24} lg={12}>
        <Form.Item
          name={[contractorKey, 'legal_entity', 'name']}
          label={t('company_name')}
          rules={[required, companyName]}
        >
          <Input disabled={isEditable} placeholder={t('company_name')} />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item
          name={[contractorKey, 'legal_entity', 'identification_number']}
          label={t(isFiscalCode ? 'fiscal_code' : 'identification_number')}
          rules={[
            ...(notRequiredIdno ? [] : [required]),
            isFiscalCode ? fiscalCode : legalPersonalCode
          ]}
        >
          <Input
            disabled={isEditable}
            placeholder={t('identification_number')}
          />
        </Form.Item>
      </Col>

      {children}
    </Row>
  )
}
